<template>
  <v-dialog v-model="userShow" persistent :max-width="conWidth">
    <v-card :class="classContents">
      <v-card-title>
        <h3>{{ this.$t('alert.user.settings') }}</h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeComp()">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form ref="form" v-if="showContent">
        <v-row class="mx-3 mb-3">
          <v-col cols="12">
            <v-card flat class="dialog-form" :class="classContents">
              <div class="d-flex flex-column">
                <div class="my-1">
                  <div class="float-left column-name">
                    <span class="d-flex align-center">{{ this.$t('alert.user.system') }}</span>
                  </div>
                  <div class="float-left column-contents">
                    <v-text-field v-model="copyPropFormData.systemId" class="w-auto" outlined dense :disabled="true" :hide-details="true"></v-text-field>
                  </div>
                </div>
                <template v-if="dscType === 'kpi'">
                  <div class="my-1">
                    <div class="float-left column-name">
                      <span class="d-flex align-center">{{ this.$t('alert.user.alertType') }}</span>
                    </div>
                    <div class="float-left column-contents">
                      <v-text-field v-model="copyPropFormData.alertType" class="w-auto" outlined dense :disabled="true" :hide-details="true"></v-text-field>
                    </div>
                  </div>
                  <div class="my-1">
                    <div class="float-left column-name">
                      <span class="d-flex align-center">{{ this.$t('alert.description') }}</span>
                    </div>
                    <div class="float-left column-contents">
                      <v-text-field v-model="copyPropFormData.message" class="w-auto" outlined dense :disabled="true" :hide-details="true"></v-text-field>
                    </div>
                  </div>
                </template>
                <template v-else-if="dscType === 'abapDump'">
                  <div class="my-1">
                    <div class="float-left column-name">
                      <span class="d-flex align-center">{{ this.$t('alert.user.warningType') }}</span>
                    </div>
                    <div class="float-left column-contents">
                      <v-text-field v-model="copyPropFormData.sapDataCode" class="w-auto" outlined dense :disabled="true" :hide-details="true"></v-text-field>
                    </div>
                  </div>
                  <div class="my-1">
                    <div class="float-left column-name">
                      <span class="d-flex align-center">{{ this.$t('alert.user.abapId') }}</span>
                    </div>
                    <div class="float-left column-contents">
                      <v-text-field v-model="copyPropFormData.alertCode" class="w-auto" outlined dense :disabled="true" :hide-details="true"></v-text-field>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="my-1">
                    <div class="float-left column-name">
                      <span class="d-flex align-center">{{ this.$t('alert.user.warningType') }}</span>
                    </div>
                    <div class="float-left column-contents">
                      <v-text-field v-model="copyPropFormData.sapDataCodeText" class="w-auto" outlined dense :disabled="true" :hide-details="true"></v-text-field>
                    </div>
                  </div>
                  <div class="my-1">
                    <div class="float-left column-name">
                      <span class="d-flex align-center">{{ this.$t('alert.monitor.programName') }}</span>
                    </div>
                    <div class="float-left column-contents">
                      <v-text-field v-model="copyPropFormData.programName" class="w-auto" outlined dense :disabled="true" :hide-details="true"></v-text-field>
                    </div>
                  </div>
                </template>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
      <v-container>
        <v-data-table :headers="headers" :items="copyAlertUsers" item-key="userId" :loading="loading" class="table-pd-s" height="200px" dense fixed-header disable-pagination hide-default-footer>
          <template v-slot:item.warningTray="{ item }">
            <v-checkbox v-model="item.warningTray" dense hide-details></v-checkbox>
          </template>
          <template v-slot:item.warningEmail="{ item }">
            <v-checkbox v-model="item.warningEmail" dense hide-details></v-checkbox>
          </template>
          <template v-slot:item.warningSms="{ item }">
            <v-checkbox v-model="item.warningSms" dense hide-details></v-checkbox>
          </template>
          <template v-slot:item.warningPush="{ item }">
            <v-checkbox v-model="item.warningPush" dense hide-details></v-checkbox>
          </template>
          <template v-slot:item.criticalTray="{ item }" v-if="isShowCritical">
            <v-checkbox v-model="item.criticalTray" dense hide-details></v-checkbox>
          </template>
          <template v-slot:item.criticalEmail="{ item }" v-if="isShowCritical">
            <v-checkbox v-model="item.criticalEmail" dense hide-details></v-checkbox>
          </template>
          <template v-slot:item.criticalSms="{ item }" v-if="isShowCritical">
            <v-checkbox v-model="item.criticalSms" dense hide-details></v-checkbox>
          </template>
          <template v-slot:item.criticalPush="{ item }" v-if="isShowCritical">
            <v-checkbox v-model="item.criticalPush" dense hide-details></v-checkbox>
          </template>
        </v-data-table>
      </v-container>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn @click="save()" :loading="loading" small color="primary">{{ this.$t('common.save') }}</v-btn>
        <v-btn @click="closeComp()" small color="primary">{{ this.$t('common.cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { cloneDeep, pickBy, isBoolean, isEqual, differenceWith, values, forEach } from 'lodash';

export default {
  name: 'AlertUser',
  components: {},
  props: {
    userFormData: Object,
    uiType: {
      type: String,
      default: 'normal',
    },
    dscType: {
      type: String,
      default: 'kpi',
    },
  },
  data() {
    return {
      userShow: false,
      showContent: false,
      loading: true,
      copyPropFormData: {},
      copyAlertUsers: [],
    };
  },
  computed: {
    ...mapState('preference/alert', ['alertUsers', 'updateUsers']),
    isShowCritical() {
      return this.uiType !== 'normal' ? true : false;
    },
    isDscType() {
      return this.dscType !== 'kpi' ? true : false;
    },
    conWidth() {
      return this.isShowCritical ? '680px' : '550px';
    },
    classContents() {
      return {
        'contents-background-dark': this.$vuetify.theme.isDark,
      };
    },
    headers() {
      const headers = [
        { text: this.$t('alert.user.id'), value: 'userId', width: '15%', sortable: false },
        { text: 'Tray', value: 'warningTray', align: 'center', sortable: false },
        { text: 'E-mail', value: 'warningEmail', align: 'center', sortable: false },
        { text: 'SMS', value: 'warningSms', align: 'center', sortable: false },
        { text: 'Push', value: 'warningPush', align: 'center', sortable: false },
      ];
      const apiHeaders = [
        { text: this.$t('alert.user.criticalTray'), value: 'criticalTray', align: 'center', sortable: false },
        { text: this.$t('alert.user.criticalEmail'), value: 'criticalEmail', align: 'center', sortable: false },
        { text: this.$t('alert.user.criticalSms'), value: 'criticalSms', align: 'center', sortable: false },
        { text: this.$t('alert.user.criticalPush'), value: 'criticalPush', align: 'center', sortable: false },
      ];
      if (this.isShowCritical) return [...headers, ...apiHeaders];
      return headers;
    },
  },
  watch: {
    copyPropFormData() {
      this.showContent = true;
      this.fetchAlertUsers();
    },
    alertUsers(val) {
      this.copyAlertUsers = cloneDeep(val);
    },
    copyAlertUsers() {
      this.loading = false;
    },
    userShow(val) {
      if (val) this.copydata();
    },
    updateUsers(val) {
      if (val === 'success') this.closeComp();
    },
  },
  methods: {
    async copydata() {
      this.copyPropFormData = await { ...this.userFormData };
    },
    resetDatas() {
      this.copyPropFormData = {};
      this.copyAlertUsers = [];
    },
    fetchAlertUsers() {
      const params = {
        systemId: this.copyPropFormData.systemId,
        sapDataCode: this.copyPropFormData.sapDataCode,
        alertCode: this.copyPropFormData.alertCode,
      };
      this.$store.dispatch('preference/alert/alertUsers', params);
    },
    closeComp() {
      this.userShow = false;
    },
    allCheckValue(val = []) {
      return values(pickBy(val, isBoolean)).every(el => el === false);
    },
    makeParams(differences) {
      let paramData = [];
      forEach(differences, value => {
        let isAllFalse = this.allCheckValue(value);
        if (value.status !== 'NOTEXISTED') {
          value.status = isAllFalse ? 'DELETED' : 'UPDATED';
        } else {
          value.status = isAllFalse ? 'NOTEXISTED' : 'INSERTED';
        }
        paramData.push(value);
      });
      this.$store.dispatch('preference/alert/updateAlertUsers', paramData);
    },
    save() {
      const differences = differenceWith(this.copyAlertUsers, this.alertUsers, isEqual);
      if (!differences.length) {
        this.closeComp();
      } else {
        this.makeParams(differences);
      }
    },
  },
};
</script>
